import { render, staticRenderFns } from "./GSchoolClassChangeStudentTile.vue?vue&type=template&id=d1580c94&"
import script from "./GSchoolClassChangeStudentTile.vue?vue&type=script&lang=ts&"
export * from "./GSchoolClassChangeStudentTile.vue?vue&type=script&lang=ts&"
import style0 from "./GSchoolClassChangeStudentTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports